import {
  Button,
  Input,
  Select,
  SelectItem,
  Textarea,
  useDisclosure,
} from "@nextui-org/react";
import React, { useState } from "react";
import { useEffect } from "react";
import {
  PublishData,
  capitalize,
  getDataWithFilterUrl,
} from "../../controllers/APIController";
import MarkdownEditor from "../Dashboard/MarkdownEditor";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import useGetAllOrganization from "../../hooks/useGetAllOrganization";
import LoadingPage from "../../components/Loader/LoadingPage";
import CreateMarkDownWithAI from "./CreateMarkDownWithAI";
import { StandardCancelButton, StandardDeleteButton } from "../../components/StandardButtons";

const createUploadDataForPolicyBuilder = (
  data,
  OrgInfo,
  markDownContent,
  metricValueList
) => {
  const uploadData = {
    Name: data.name,
    Description: data.description,
    Organization: OrgInfo,
  };
  if (data?.policyType === "policy") {
    uploadData.DomainId = data.domain;
    uploadData.PolicyFramework = markDownContent;
  } else if (data?.policyType === "procedure") {
    uploadData.PolicyId = data.policy;
    uploadData.ControlMetrics = { controlMetrics: metricValueList };
    uploadData.ProcedureFramework = markDownContent;
  }

  return uploadData;
};
const createpolicyDetailFromExtenalData = (data, type) => {
  const policyDetail = {
    name: data?.attributes?.Name,
    description: data?.attributes?.Description,
    policyType: type,
    domain: data?.attributes?.DomainId?.data?.id || null,
    policy: data?.attributes?.PolicyId?.data?.id || null,
  };

  const markDownContent =
    data?.attributes?.PolicyFramework ||
    data?.attributes?.ProcedureFramework ||
    "";

  const metricValueList =
    data?.attributes?.ControlMetrics?.controlMetrics || [];

  return [policyDetail, markDownContent, metricValueList];
};
const pulizirePolicyName = {
  domain: "domains",
  policy: "policies",
  procedure: "procedures",
};
const EditPoliciesBuilder = () => {
  const [isLoading, setisLoading] = useState(true);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [userRole, setUserRole] = useState("");
  const [metricValueList, setMetricValueList] = useState([]);
  const [markDownContent, setMarkDownContent] = useState("");

  const [policyDetails, setPolicyDetails] = useState({
    name: "",
    description: "",
    policyType: "",
    domain: null,
    policy: null,
  });
  const [allDomainPolicyProcedure, setAllDomainPolicyProcedure] = useState({
    domainList: [],
    policyList: [],
  });
  const [metricFormList, setMetricFormList] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [isViewMode, setIsViewMode] = useState(true); // Start in view mode

  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onOpenChange: onModalOpenChange,
  } = useDisclosure();

  const [searchParams, setSearchParams] = useSearchParams();
  const policyType = searchParams.get("type");

  const navigate = useNavigate();
  const { _orgId: currOrg, _responseId } = useParams();

  const policyTypeList = [
    { id: "domain", title: "Domain" },
    { id: "policy", title: "Policy" },
    { id: "procedure", title: "Procedure" },
  ];

  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const OrgInfo = UserLogged && UserLogged.user.LastOrgId;
  const orgFilterUrl = "filters[Organization][id][$eqi]=" + OrgInfo;

  const changeHandler = (key, value) => {
    setPolicyDetails((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
  const validationHandler = () => {
    let isValid = true;
    const errorMessage = {};
    if (!policyDetails?.name || policyDetails?.name?.trim() === "") {
      errorMessage["name"] = "Name is required!";
      isValid = false;
    }
    if (
      !policyDetails?.description ||
      policyDetails?.description?.trim() === ""
    ) {
      errorMessage["description"] = "Description is required!";
      isValid = false;
    }
    if (
      !policyDetails?.policyType ||
      policyDetails?.policyType?.trim() === ""
    ) {
      errorMessage["policyType"] = "Type is required!";
      isValid = false;
    }
    if (
      policyDetails?.policyType === "policy" &&
      (!policyDetails?.domain || policyDetails?.domain?.toString()?.trim() === "")
    ) {
      errorMessage["domain"] = "domain is required!";
      isValid = false;
    }
    if (
      policyDetails?.policyType === "procedure" &&
      (!policyDetails?.policy || policyDetails?.policy?.toString()?.trim() === "")
    ) {
      errorMessage["policy"] = "Policy is required!";
      isValid = false;
    }
    setValidationErrors(errorMessage);

    return isValid;
  };
  const submitHandler = async () => {
    const isValid = validationHandler();
    if (!isValid) {
      return;
    }

    const uploadData = createUploadDataForPolicyBuilder(
      policyDetails,
      OrgInfo,
      markDownContent,
      metricValueList
    );

    const collectionName = pulizirePolicyName?.[policyDetails?.policyType];

    let result = await PublishData({ data: uploadData }, collectionName);

    navigate(-1);
  };
  //   const data = {};

  useEffect(() => {
    getDataWithFilterUrl("metrics", orgFilterUrl)
      .then((data) => {
        let list = data.data;
        list.sort((a, b) => {
          if (
            a?.attributes?.Name.trim().toLowerCase() <
            b?.attributes?.Name.trim().toLowerCase()
          ) {
            return -1;
          }
          if (
            a?.attributes?.Name.trim().toLowerCase() >
            b?.attributes?.Name.trim().toLowerCase()
          ) {
            return 1;
          }
          return 0;
        });

        list = list.map((item) => {
          return {
            id: item.id,
            title: item?.attributes?.Name,
          };
        });
        setMetricFormList(list);
        // Check if all required data is loaded
        if (allDomainPolicyProcedure.domainList.length > 0 || allDomainPolicyProcedure.policyList.length > 0) {
          setIsDataLoaded(true);
          setisLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error loading metrics:", err);
        // Set empty list on error to prevent crashes
        setMetricFormList([]);
      });
  }, []);

  useEffect(() => {
    const policyList = [];
    const domainList = [];
    let randomId = 0;
    
    // Load domains and policies in parallel for better performance
    Promise.all([
      getDataWithFilterUrl("domains", orgFilterUrl),
      getDataWithFilterUrl("policies", orgFilterUrl)
    ])
      .then(([domainData, policyData]) => {
        // Process domain data
        domainData?.data?.forEach((element) => {
          domainList.push({
            randomId: randomId++,
            id: element.id,
            name: element?.attributes?.Name,
            description: element?.attributes?.Description || "--",
          });
        });
        
        // Process policy data
        policyData?.data?.forEach((element) => {
          policyList.push({
            randomId: randomId++,
            id: element.id,
            name: element?.attributes?.Name,
            description: element?.attributes?.Description || "--",
            type: "policy",
          });
        });
        
        setAllDomainPolicyProcedure({
          domainList,
          policyList,
        });
        
        // Don't wait for metricFormList for basic policy viewing
        // Only set loading to false if we're not already loading policy details
        if (!_responseId || !policyType) {
          setIsDataLoaded(true);
          setisLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error loading domains/policies:", err);
        // Set empty lists on error to prevent crashes
        setAllDomainPolicyProcedure({ domainList: [], policyList: [] });
      });
  }, [orgFilterUrl]);

  useEffect(() => {
    if (!_responseId || !policyType) return;
    
    const filteredUrl = `${orgFilterUrl}&filters[id][$eqi]=${_responseId}`;
    const collectionName = pulizirePolicyName[policyType];

    getDataWithFilterUrl(collectionName, filteredUrl)
      .then((data) => {
        if (data?.data?.[0]) {
          const [policyDetail, markDownContentData, selectedMetricList] =
            createpolicyDetailFromExtenalData(data.data[0], policyType);
          setMarkDownContent(markDownContentData);
          setPolicyDetails(policyDetail);
          setMetricValueList(selectedMetricList);
          // Set data as loaded when we have the main policy data
          setIsDataLoaded(true);
          setisLoading(false);
        } else {
          // No data found, still set as loaded to show error state
          setIsDataLoaded(true);
          setisLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error loading policy details:", err);
        // Set as loaded even on error to show error state
        setIsDataLoaded(true);
        setisLoading(false);
      });
  }, [_responseId, policyType, orgFilterUrl]);

  return (
    <BreadCrumbsPage>
      <>
        <LoadingPage isLoading={isLoading || !isDataLoaded} loadingText="Loading policy builder...">
          <div className="max-w-6xl mx-auto p-6">
            <div className="mb-6">
              <div className="flex items-center justify-between">
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">
                    {isViewMode ? 'View Policy Details' : 'Edit Policy Builder'}
                  </h1>
                  <p className="text-gray-600 mt-2">
                    {isViewMode ? 'Review policy information' : 'Modify your policy configuration'}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <Button
                    color="default"
                    variant="light"
                    onClick={() => navigate(-1)}
                    className="min-w-0"
                  >
                    Back
                  </Button>
                  <Button
                    color={isViewMode ? "primary" : "secondary"}
                    variant="flat"
                    onClick={() => setIsViewMode(!isViewMode)}
                    className="min-w-0"
                  >
                    {isViewMode ? 'Edit Policy' : 'View Details'}
                  </Button>
                </div>
              </div>
            </div>
            <div>
              <p className="text-3xl font-medium">
                {isViewMode ? policyDetails?.name || 'Policy Details' : 'Edit Policy Builder'}
              </p>
              {isViewMode ? (
                // View Mode - Show policy details
                <div className="space-y-6 my-12">
                  {policyDetails ? (
                    <>
                      {/* Basic Information */}
                      <div className="bg-white rounded-lg border border-gray-200 p-6">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">Basic Information</h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <label className="text-sm font-medium text-gray-700">Type</label>
                            <p className="text-sm text-gray-900 mt-1">
                              {policyDetails?.policyType ? capitalize(policyDetails.policyType) : 'Not specified'}
                            </p>
                          </div>
                          <div>
                            <label className="text-sm font-medium text-gray-700">Name</label>
                            <p className="text-sm text-gray-900 mt-1">
                              {policyDetails?.name || 'Not specified'}
                            </p>
                          </div>
                          <div className="md:col-span-2">
                            <label className="text-sm font-medium text-gray-700">Description</label>
                            <p className="text-sm text-gray-900 mt-1">
                              {policyDetails?.description || 'No description available'}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Type-specific Information */}
                      {policyDetails?.policyType === 'policy' && (
                        <div className="bg-white rounded-lg border border-gray-200 p-6">
                          <h3 className="text-lg font-semibold text-gray-900 mb-4">Policy Information</h3>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <label className="text-sm font-medium text-gray-700">Domain</label>
                              <p className="text-sm text-gray-900 mt-1">
                                {allDomainPolicyProcedure?.domainList?.find(d => d.id === policyDetails?.domain)?.name || 'Not specified'}
                              </p>
                            </div>
                            <div>
                              <label className="text-sm font-medium text-gray-700">Framework</label>
                              <p className="text-sm text-gray-900 mt-1">
                                {markDownContent ? 'Available' : 'Not available'}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      {policyDetails?.policyType === 'procedure' && (
                        <div className="bg-white rounded-lg border border-gray-200 p-6">
                          <h3 className="text-lg font-semibold text-gray-900 mb-4">Procedure Information</h3>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <label className="text-sm font-medium text-gray-700">Policy</label>
                              <p className="text-sm text-gray-900 mt-1">
                                {allDomainPolicyProcedure?.policyList?.find(p => p.id === policyDetails?.policy)?.name || 'Not specified'}
                              </p>
                            </div>
                            <div>
                              <label className="text-sm font-medium text-gray-700">Control Metrics</label>
                              <p className="text-sm text-gray-900 mt-1">
                                {metricValueList?.length || 0} metrics
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="text-center py-12">
                      <p className="text-gray-600">No policy details available.</p>
                    </div>
                  )}
                </div>
              ) : (
                // Edit Mode - Show form fields
                <div className="flex flex-col gap-4 my-12 w-[50%]">
                  {/* Policy Type */}
                  <Select
                    label="Type"
                    isDisabled
                    placeholder="Choose a Category"
                    variant="faded"
                    selectionMode="single"
                    labelPlacement="outside"
                    className=""
                    selectedKeys={new Set([policyDetails?.policyType])}
                    onSelectionChange={(event) =>
                      changeHandler("policyType", Array.from(event)[0])
                    }
                    errorMessage={validationErrors["policyType"]}
                    isInvalid={validationErrors["policyType"]}
                  >
                    {policyTypeList?.map((item) => (
                      <SelectItem key={item.id} value={item.title} className="py-2">
                        {item.title}
                      </SelectItem>
                    ))}
                  </Select>

                  {/* Name */}
                  <Input
                    type="text"
                    className=""
                    isRequired
                    label={"Name"}
                    placeholder={" "}
                    variant="faded"
                    labelPlacement="outside"
                    value={policyDetails?.name}
                    onChange={(event) => {
                      changeHandler("name", event.target.value);
                    }}
                    isInvalid={validationErrors["name"]}
                    errorMessage={validationErrors["name"]}
                  />
                  
                  {/* Description */}
                  <Textarea
                    className=""
                    label={"Description"}
                    isRequired
                    value={policyDetails?.description}
                    placeholder={" "}
                    variant="faded"
                    labelPlacement="outside"
                    onChange={(event) => {
                      changeHandler("description", event.target.value);
                    }}
                    isInvalid={validationErrors["description"]}
                    errorMessage={validationErrors["description"]}
                  />

                  {/* Domain for policy  */}
                  {policyDetails?.policyType === "policy" && allDomainPolicyProcedure?.domainList && (
                    <Select
                      label="Domain"
                      placeholder="Choose a Domain"
                      variant="faded"
                      selectionMode="single"
                      labelPlacement="outside"
                      className="my-4"
                      selectedKeys={(() => {
                        const domainId = policyDetails?.domain?.toString();
                        // Only set selectedKeys if the domain exists in the loaded domainList
                        if (domainId && allDomainPolicyProcedure?.domainList?.some(item => item.id.toString() === domainId)) {
                          return new Set([domainId]);
                        }
                        return new Set();
                      })()}
                      onSelectionChange={(event) =>
                        changeHandler("domain", Array.from(event)[0])
                      }
                      errorMessage={validationErrors["domain"]}
                      isInvalid={validationErrors["domain"]}
                    >
                      {allDomainPolicyProcedure?.domainList?.map((item) => (
                        <SelectItem key={item.id} value={item.name} className="py-2">
                          {item.name}
                        </SelectItem>
                      ))}
                    </Select>
                  )}

                  {/* Policy for procedure */}
                  {policyDetails?.policyType === "procedure" && allDomainPolicyProcedure?.policyList && (
                    <Select
                      label="Policy"
                      placeholder="Choose a Policy"
                      variant="faded"
                      selectionMode="single"
                      labelPlacement="outside"
                      className="my-4"
                      selectedKeys={(() => {
                        const policyId = policyDetails?.policy?.toString();
                        // Only set selectedKeys if the policy exists in the loaded policyList
                        if (policyId && allDomainPolicyProcedure?.policyList?.some(item => item.id.toString() === policyId)) {
                          return new Set([policyId]);
                        }
                        return new Set();
                      })()}
                      onSelectionChange={(event) =>
                        changeHandler("policy", Array.from(event)[0])
                      }
                      errorMessage={validationErrors["policy"]}
                      isInvalid={validationErrors["policy"]}
                    >
                      {allDomainPolicyProcedure?.policyList?.map((item) => (
                        <SelectItem key={item.id} value={item.name} className="py-2">
                          {item.name}
                        </SelectItem>
                      ))}
                    </Select>
                  )}

                  {/* Form-Metric Choosen Input */}
                  {policyDetails?.policyType === "procedure" && metricFormList && (
                    <Select
                      label="Control Metrics"
                      placeholder="Select any Metrics"
                      variant="faded"
                      selectionMode="multiple"
                      labelPlacement="outside"
                      className="my-8"
                      selectedKeys={(() => {
                        // Only set selectedKeys for metrics that exist in the loaded metricFormList
                        if (metricValueList && metricFormList) {
                          const validMetrics = metricValueList.filter(metricId => 
                            metricFormList.some(item => item.id.toString() === metricId.toString())
                          );
                          return new Set(validMetrics);
                        }
                        return new Set();
                      })()}
                      onSelectionChange={(event) =>
                        setMetricValueList(Array.from(event))
                      }
                    >
                      {metricFormList?.map((item) => (
                        <SelectItem key={item.id} value={item.title} className="py-2">
                          {item.title}
                        </SelectItem>
                      ))}
                    </Select>
                  )}

                  {(policyDetails?.policyType === "policy" ||
                    policyDetails?.policyType === "procedure") && (
                    <div>
                      <div className="flex items-center justify-between">
                        <p className="text-sm font-medium">
                          Describe {capitalize(policyDetails?.policyType || "")}
                        </p>
                        <Button size="sm" color="warning" onClick={onModalOpen} aria-label="Create content with AI">
                          Create with AI
                        </Button>
                      </div>
                      <MarkdownEditor
                        descriptionContent={markDownContent}
                        setDescriptionContent={setMarkDownContent}
                      />
                    </div>
                  )}
                  
                  <div className="flex justify-end gap-4 my-4 w-full">
                    <StandardCancelButton onClick={() => navigate(-1)} aria-label="Cancel editing">
                      Cancel
                    </StandardCancelButton>
                    <StandardDeleteButton
                      onClick={submitHandler}
                      className={`cursor-pointer`}
                      aria-label="Update policy"
                    >
                      Update
                    </StandardDeleteButton>
                  </div>
                </div>
              )}
            </div>
          </div>
        </LoadingPage>
        
        <CreateMarkDownWithAI
          isOpen={isModalOpen}
          onOpen={onModalOpen}
          onOpenChange={onModalOpenChange}
          onSubmitHandler={(data) => {
            setMarkDownContent(data);
          }}
        />
      </>
    </BreadCrumbsPage>
  );
};

export default EditPoliciesBuilder;
